export class TranslationHeader {
	private _columnName: string;
	private _systemName: string | null = null;

	constructor(columnName: string, systemName?: string) {
		this._columnName = columnName;
        this._systemName = systemName ?? null;
	}

	get Title(): string {
		return this._columnName;
	}

    get SystemName(): string | null {
        return this._systemName;
    }
}